import React from 'react';
import PropTypes from 'prop-types';

import './index.sass';

const Background = ({className, name, type}) => {
	const gradient = 'linear-gradient(to right, rgba(99, 147, 147, .6), rgba(30, 62, 96, .6))';
	const bucket = type? `roverpix-${type}-backgrounds` : "roverpix-backgrounds"
	const baseUrl = `https://s3.amazonaws.com/${bucket}/${name.toLowerCase()}`;
	const layer = (suffix) => `url("${baseUrl}_${suffix}.png")`;

	return (
		<div
			className={`Background ${type ? `Background--${type}` : ''} ${className}`}
			style={name
				? {
					'--bg-base': `url("${baseUrl}.jpg")`,
					'--bg-left': layer('left'),
					'--bg-right': layer('right'),
					'--bg-mobile-top': layer('mobile_top'),
					'--bg-mobile-bottom': layer('mobile_bottom')
				}
				: {backgroundImage: gradient}
			}
		/>
	);
};

Background.propTypes = {
	className: PropTypes.string,
	name: PropTypes.string,
    type: PropTypes.oneOf(['', 'gallery'])
};

Background.defaultProps = {
	className: '',
	name: '',
	type: ''
};

export default Background;
